export default "__VITE_ASSET__DoOFpph1__"